import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';
import MockUpUtil from 'edge/api/gw-portals-util-js/MockUpUtil';
import MetadataDrivenUtil from 'edge/api/gw-portals-driven-ui-js/MetadataDrivenUtil';

/**
 * This function prepares some common actions to be used in flow configuration
 *
 * @param {Object} dependencies
 * @param {Object} dependencies.$q a Promise implementation
 * @param {Object} dependencies.LoadSaveService
 * @param {Object} dependencies.ViewModelService
 * @param {Object} dependencies.ViewModelContext
 *
 * @returns {Object} a set of common Flow actions 'ret.ACTIONS' an their respective message 'ret.ACTIONS_MSG' to be used across all the custom flows
 */

const mockUpUtil = new MockUpUtil();

const fn = ($filter, $scope, $state, $stateParams, $translate,
    ViewModelService, InsuranceSuiteMetadata, UserInfoService, ModalService, PolicyService, AccountBillingDetailsService) => {
    const ctrl = Object.create(BaseCtrl);


    $scope.data = [];
    var viewModel = {};
    /*1) In force (Active)
    2) Canceled
    3) Expired
    4) All*/
    $scope.statusList = [
        'In force (Active)', 'Canceled', 'Expired', 'All'
    ];
    const today = new Date();

    $scope.today = {
        year: today.getFullYear(),
        month: today.getMonth(),
        day: today.getDate()
    };

    ctrl.init = () => {
        if (PSAUSER !== undefined) {
            if (PSAUSER.isDelearLeadOrAudit == undefined || PSAUSER.isDelearLeadOrAudit == false) {
                ModalService.showError('gateway.views.modal.Error', 'gPermission Denied');
                return false
            }
            else {
                $scope.submissionView = ViewModelService.create(viewModel, 'pc', 'edge.capabilities.quote.submission.dto.ReportDTO');
            }
        }
    };

    ctrl.cancel = function () {
        window.location.hash = "#/PUWReport/"
    };

    ctrl.save = function (form) {
        var firstDate = new Date($scope.submissionView.value.fromDate.year,
            $scope.submissionView.value.fromDate.month, $scope.submissionView.value.fromDate.day)
        var lastDate = new Date($scope.submissionView.value.toDate.year,
            $scope.submissionView.value.toDate.month, $scope.submissionView.value.toDate.day)
        var fDate = moment(firstDate)
        var lDate = moment(lastDate)
        //INCI11796175 -  ISSUE WITH REPORTS ON THE PORTAL
        var MonthsDiff = moment.duration(lDate.diff(fDate)).asMonths();
        var daysDiff = moment.duration(lDate.diff(fDate)).asDays();

        if (MonthsDiff > 3 && (daysDiff > 90 || daysDiff < 0) || MonthsDiff < 0) {
            ModalService.showError('gateway.views.modal.Error', 'PSA.Web.PSAReport.timeframe');
            return;
        }

        const operation = AccountBillingDetailsService.getBillingReportInformation($scope.submissionView.value.fromDate, $scope.submissionView.value.toDate);
        operation.then((result) => {
            if (result.length > 0) {
                $scope.RRDI = result[0].producerCode
                $scope.data = _.sortBy(result, "registrationDate")
                JSONToCSVConvertor($scope.data, " Report", true);
            }
            else {
                // Display Error message if no result
                ModalService.showError('gateway.views.modal.Error', 'gateway.directives.policy-summary.No results found for this filter');
            }
        }).catch((error) => {
            ModalService.showError('gateway.views.modal.Error', 'PSA.Web.PSAReport.error');
        });
    };

    function JSONToCSVConvertor(JSONData, ReportTitle, ShowLabel) {
        // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
        var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
        //INCI12516233 | FRA/PSA/AC/VOLTS ISSUE
        arrData = _.filter(arrData, function (data) {
          return data !=null;
        })
        var CSV = 'sep=,' + '\r\n\n';


        var firstDate = new Date($scope.submissionView.value.fromDate.year,
            $scope.submissionView.value.fromDate.month, $scope.submissionView.value.fromDate.day)
        var lastDate = new Date($scope.submissionView.value.toDate.year,
            $scope.submissionView.value.toDate.month, $scope.submissionView.value.toDate.day)
        var fDate = moment(firstDate)
        var lDate = moment(lastDate)
        // This condition will generate the Label/Header
        var rowTitle = $translate.instant('PSA.Web.PSAReport.Billing-Dealer-Report') + ",";
        CSV += rowTitle + '\r\n';
        // UCWAR-2138
        var row1 = $translate.instant('PSA.Web.PSAReport.Header.Bill-Date') + ": " + $translate.instant('PSA.Web.PSAReport.BillDealerfromDate') + " : " + fDate.format('DD/MM/YYYY') + " " + $translate.instant('PSA.Web.PSAReport.BillDealertoDate') + " " + lDate.format('DD/MM/YYYY') + ',';
        CSV += row1 + '\r\n';

        CSV += '\r\n';

        // Headers
        var headerArray = {
            "accountingCode": $translate.instant('PSA.Web.PSAReport.Header.Accounting-Code'),
            "policyNumber": $translate.instant('PSA.Web.PSAReport.Header.Policy-Number'),
            "vin": $translate.instant('PSA.Web.PSAReport.Header.VIN-Billing'),
            "invoiceNumber": $translate.instant('PSA.Web.PSAReport.Header.Invoice-Number'),
            "invoiceIDEBilling": $translate.instant('PSA.Web.PSAReport.Header.Invoice-ID-E-Billing'),
            "currency": $translate.instant('PSA.Web.PSAReport.Header.Currency'),
            "billDate": $translate.instant('PSA.Web.PSAReport.Header.Bill-Date'),
            "dueDate": $translate.instant('PSA.Web.PSAReport.Header.Due-Date'),
            "invoiceStatus": $translate.instant('PSA.Web.PSAReport.Header.Invoice-Status'),
            "producerCode": $translate.instant('PSA.Web.PSAReport.Header.Producer-Code'),
            "producerName": $translate.instant('PSA.Web.PSAReport.Header.Billing-Producer-Name'),
            "offer": $translate.instant('PSA.Web.PSAReport.Header.Offer'),
            "effectiveDatePolicy": $translate.instant('PSA.Web.PSAReport.PolicyEffectiveDate'),
            "expirationDatePolicy": $translate.instant('PSA.Web.PSAReport.Header.Policy-Expiration-Date'),
            "endCustomerName": $translate.instant('PSA.Web.PSAReport.Header.End-Customer-Name'),
            "endCustomerPostalCode": $translate.instant('PSA.Web.PSAReport.Header.End-Customer-Postal-Code'),
            "endCustomerCity": $translate.instant('PSA.Web.PSAReport.Header.End-Customer-City'),
            "coverage": $translate.instant('PSA.Web.PSAReport.Header.Coverage'),
            "context": $translate.instant('PSA.Web.PSAReport.Header.Context'),
            "managementMode": $translate.instant('PSA.Web.PSAReport.Header.Management-Mode'),
            "premium": $translate.instant('PSA.Web.PSAReport.Header.Premium'),
            "managementFeeAmount": $translate.instant('PSA.Web.PSAReport.Header.Management-Fee-Amount'),
            "vatamount": $translate.instant('PSA.Web.PSAReport.Header.VAT-Amount'),
            "iptamount": $translate.instant('PSA.Web.PSAReport.Header.IPT-Amount'),
            "collateralAmount": $translate.instant('PSA.Web.PSAReport.Header.Collateral-Amount'),
            "transactionAmountTax": $translate.instant('PSA.Web.PSAReport.Header.Transaction-Amount-Tax-Incl')
        };

        if (ShowLabel) {
            var row = "";

            // This loop will extract the label from 1st index of on array
            for (var key in headerArray) {
                row += headerArray[key] + ',';
            }

            row = row.slice(0, -1);
            // append Label row with line break
            CSV += row + '\r\n';
        }
        // 1st loop is to extract each row
        for (var i = 0; i < arrData.length; i++) {
            var row = "";
            // 2nd loop will extract each column and convert it in string comma-seprated
            for (key in headerArray) {
                if (arrData[i][key] == undefined) {
                    row += '"' + "-" + '",';
                }
                else {
                    // UCWPRODENG-823 format excel
                    if (key == "policyNumber" || key == "model") {
                        //row += '"' +arrData[i][key] + '",';
                        row += "\'" + arrData[i][key] + "\'" + ',';;
                    }
                    else if (key == "grossPremium") {
                        arrData[i][key] = parseFloat(arrData[i][key]).toFixed(2);
                        row += '"' + arrData[i][key] + '",';
                    }
                    else
                        row += '"' + arrData[i][key] + '",';
                }
            }
            row.slice(0, row.length - 1);
            // add a line break after each row
            CSV += row + '\r\n';
        }
        if (CSV == '') {
            return;
        }
        // Generate a file name
        // "RRDI**_Stellantis_Billing Dealer Report_**CurrentDate*";
        var fileName = $scope.RRDI + "_Stellantis_Billing Dealer Report_" + moment(new Date()).format('MM/DD/YYYY');

        // this will remove the blank-spaces from the title and replace it with an underscore
        fileName += ReportTitle.replace(/ /g, "_");

        // Initialize file format you want csv or xls
        var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);

        var link = document.createElement("a");
        link.href = uri;
        // set the visibility hidden so it will not effect on your web-layout
        link.style = "visibility:hidden";
        link.download = fileName + ".csv";
        // this part will append the anchor tag and remove it after automatic click
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
    return ctrl.create($scope);
};

fn.$inject = ['$filter', '$scope', '$state', '$stateParams', '$translate', 'ViewModelService', 'InsuranceSuiteMetadata', 'UserInfoService', 'ModalService', 'PolicyService', 'billing.AccountBillingDetailsService'];
export default fn;
